export enum HeaderFeatures {
  LOGOUT_BUTTON = 'LOGOUT_BUTTON',
  DROP_DOWN_MENU = 'DROP_DOWN_MENU',
}
